import React from "react";
import { Box, Chip, Container, Paper, Stack, Typography } from "@mui/material";
import PageTitle from "../components/common/PageTitle";
import PersonalAccessTokensPanel from "../components/profile/PersonalAccessTokensPanel";
import { useAuth } from "../contexts/AuthContext";
import { getTenantId } from "../utils/jwtUtils";

const sectionPaperSx = {
  borderRadius: 2,
  border: "1px solid",
  borderColor: "divider",
  bgcolor: "background.paper",
  p: 3,
} as const;

const ProfilePage: React.FC = () => {
  const { user, activeTenantId } = useAuth();
  const tenantId = activeTenantId ?? user?.tenantId ?? getTenantId() ?? "—";

  return (
    <>
      <PageTitle
        pageTitle="Profile"
        pageDescription="Manage your account and access tokens for this organization"
      />

      <Container maxWidth="lg" sx={{ py: 3 }}>
        <Stack spacing={3}>
        <Paper sx={sectionPaperSx}>
          <Typography variant="h6" gutterBottom>
            Account
          </Typography>
          <Box sx={{ display: "grid", gap: 1.5, maxWidth: 480 }}>
            <Box>
              <Typography variant="caption" color="text.secondary">
                Email
              </Typography>
              <Typography variant="body1">{user?.email ?? "—"}</Typography>
            </Box>
            <Box>
              <Typography variant="caption" color="text.secondary">
                Organization
              </Typography>
              <Typography variant="body1">{tenantId}</Typography>
            </Box>
            {user?.roles?.length ? (
              <Box>
                <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 0.5 }}>
                  Roles
                </Typography>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75 }}>
                  {user.roles.map((role) => (
                    <Chip key={role} size="small" label={role} />
                  ))}
                </Box>
              </Box>
            ) : null}
          </Box>
        </Paper>

        <Paper sx={sectionPaperSx}>
          <PersonalAccessTokensPanel />
        </Paper>
      </Stack>
      </Container>
    </>
  );
};

export default ProfilePage;
